import { message } from 'antd';
import Trip from './Trip'
import { connect } from 'react-redux'
import { reduxForm, submit, getFormValues, change } from 'redux-form'
import { push } from 'react-router-redux'

import { createTrip, onSelectPurpose, onDateChange } from './actions'
import { requestDirections } from '../map/actions'
import onMount from '../core/onMount'
import { getPurposes, calculateDeduction } from './reducer'
import { validate } from './'
const mapStateToProps = (state, ownProps) => {
  const { work_mileage_rate, irs_mileage_rates } = state.models.user
  const tripForm = getFormValues('trip')(state)

  // calculating deduction from reduxForm
  const deduction = tripForm && tripForm.miles
    ? calculateDeduction(irs_mileage_rates, work_mileage_rate, tripForm.miles, tripForm.purpose) : 0

  const getValuesFromLast = ({models}) =>
    models.trips[0] ?
    {
      income_source: models.trips[0].income_source,
      purpose: models.trips[0].purpose,
      vehicle_id: models.trips[0].vehicle_id
    } : {
      income_source: null,
      purpose: 'Work'
    }

  return {
    title: `New Trip`,
    buttonTitle: 'Save',
    initialValues: {
      ...getValuesFromLast(state),
      // miles: 0,
      calculate_route_enabled: true,
      auto_detected: false,
      date: new Date(),
    },
    purposes: getPurposes(state),
    vehicleOptions: state.models.vehicles.map(v=>
      ({title: v.nickname || `${v.make} ${v.model}`, value: v.id, icon_name: v.icon_name})
    ),
    date: tripForm && tripForm.date ? tripForm.date : new Date(),
    // calculate_route_enabled: true, //state.map.calculate_route_enabled,
    round_trip_enabled: tripForm && tripForm.round_trip_enabled,
    purposeSelectValue: (tripForm && tripForm.income_source) || (tripForm && tripForm.purpose) || 'Work',
    deduction,
    kms_enabled: state.models.user.kms_enabled,
    hasOriginDestination: state.map.origin && state.map.destination,
    allowCustomAddress: true
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDateChange: (e)=>dispatch(onDateChange(e)),
    save: ()=> dispatch(submit('trip')),
    toggleRoundTrip: (isEnabled)=> {
      dispatch(change('trip', 'round_trip_enabled', isEnabled))

      if (isEnabled) {
        dispatch(change('trip', 'calculate_route_enabled', true))
        // dispatch({type:'CLEAR_MAP'})
        dispatch({type: 'ENABLE_ROUND_TRIP'})
        dispatch(requestDirections())
      } else {

        // RESET DESTINATION
        // dispatch({type: 'CLEAR_MAP'})
        //
        // dispatch({type: 'CLEAR_DIRECTIONS'})
        dispatch({type: 'DISABLE_ROUND_TRIP'})

        dispatch(requestDirections())


      }
    },
    // toggleCalculateRoute: ()=> console.log('no reason to disable calc route for /new'),//dispatch(toggleCalculateRoute()),
    onSelectPurpose: (purpose)=> dispatch(onSelectPurpose(purpose)),
    onUpload: (file)=> dispatch(change('trip', 'photo_attributes', file)),
    dispatch,
    ownProps
  }
}
const Create = reduxForm({
  form: 'trip',
  validate,
  onSubmit: (values, dispatch)=> dispatch(createTrip(values))
    .then(()=>message.success('Created new trip successfully.', 10))
    .then(()=> dispatch(push(`/trips`)) ),

})(Trip)

const MountedCreate = onMount(({dispatch, ownProps}) => dispatch({type: 'RESET_INITIAL_MAP_STATE'}) )(Create)

export default connect(mapStateToProps, mapDispatchToProps)(MountedCreate)



// WEBPACK FOOTER //
// ./src/trips/Create.js